import PropTypes from 'prop-types';
import FJPhotoRemoveBgCustomLeft from '../view/FJPhotoRemoveBgCustomLeft';
import FJActionPhotoBgRemover from '../../../../redux/action/FJActionPhotoBgRemover';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';
import {
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
    UPLOAD_FILE_TYPE_IMAGE_EXTENDER,
    UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE,
} from '../../../../config/dataConfig/FJGenerateData.js';

const FJPhotoRemoveBgCustomLeftContainer = props => {
    useLocalStore();
    const { isShow } = props;
    const dispatch = useDispatch();

    const isNotImage = useSelector(state => state.photoBgRemover.customEditBgImageData === null);
    const isPhotoRemoveBg = useSelector(state => state.brushEditCommon.isPhotoRemoveBg);
    const freeNumCreation = useSelector(state => state.photoBgRemover.backgroundRemoveFreeNum);
    const brushEditStatus = useSelector(state => state.brushEditCommon.brushEditStatus);

    const uploadCustomBgImage = file => {
        dispatch(FJActionPhotoBgRemover.uploadCustomBgImageFile(file));
    };

    const _openMediaLibrary = () => {
        dispatch(
            FJActionEditPage.openMediaLibraryAction({
                uploadConfig: {
                    isMultiple: false,
                    maxMediaNum: 1,
                    selectedMediaIds: [],
                    acceptTypeWithTranscode:
                        UPLOAD_FILE_TYPE_IMAGE_EXTENDER + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
                    acceptTypeNoTranscode: UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE,
                    suffixTranscode: CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
                    // 媒体库的过滤规则
                    mediaFilterFunc: item => {
                        const mediaTypes = ['IMAGE'];
                        return mediaTypes.includes(item.type);
                    },
                    // 上传文件之后返回的数据
                    callbackOptions: {},
                },
            }),
        );
    };

    return (
        <FJPhotoRemoveBgCustomLeft
            isShow={isShow}
            uploadCustomBgImage={uploadCustomBgImage}
            isNotImage={isNotImage}
            isPhotoRemoveBg={isPhotoRemoveBg}
            freeNumCreation={freeNumCreation}
            brushEditStatus={brushEditStatus}
            openMediaLibrary={_openMediaLibrary}
        />
    );
};

FJPhotoRemoveBgCustomLeftContainer.propTypes = {
    isShow: PropTypes.bool,
};

export default FJPhotoRemoveBgCustomLeftContainer;
